var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTest123 = function SvgTest123(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001731",
    d: "M12.59 0c6.618 0 12 5.383 12 12s-5.382 12-12 12c-6.616 0-12-5.383-12-12s5.384-12 12-12m3.405 4.8H13.37c-1.542 0-2.792 1.161-2.792 2.594v2.055H9.186c-.108 0-.195.081-.195.181v2.132c0 .1.087.181.195.181h1.391v7.076c0 .1.088.181.195.181h2.783c.108 0 .195-.081.195-.181v-7.076h2.017c.102 0 .187-.072.195-.166l.194-2.132c.01-.105-.08-.196-.195-.196H13.75V7.936c0-.354.31-.641.691-.641h1.554c.108 0 .196-.082.196-.182V4.981c0-.1-.088-.181-.196-.181"
  })));
};
export default SvgTest123;